import { createApiClient, constructQueryParams } from "@webelocity/api";
import { createShopApi } from "@webelocity/api";
import { getBackendUrl, getStoreIdKey } from "@webelocity/env";

const { apiFetch } = createApiClient({
  baseUrl: getBackendUrl(),
  headers: { "x-store-key": getStoreIdKey() },
});

export const shopApi = createShopApi(apiFetch as any, constructQueryParams);
export { apiFetch, constructQueryParams };
